const israeliPhoneNumberRegex = /^(9725\d{8}|05\d{8})$/;
const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export const isValidPhoneNumber = (phoneNumber: string) => {
  const cleanedPhoneNumber = phoneNumber.replace(/[\s\-+]/g, '');
  return israeliPhoneNumberRegex.test(cleanedPhoneNumber);
};

export const isValidEmail = (email: string) => {
  return emailRegex.test(email);
};

export const isNonEmptyString = (value: unknown): boolean =>
  typeof value === 'string' && value.trim().length > 0;
